module.exports = __webpack_public_path__ + "img/image-11.97225190.webp";